import(/* webpackMode: "eager", webpackExports: ["AnimatedBackground"] */ "/vercel/path0/apps/frontend/src/components/AnimatedBackground/AnimatedBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sidebar"] */ "/vercel/path0/apps/frontend/src/components/Sidebar/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/apps/frontend/src/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/apps/frontend/src/components/Theme/ThemeProvider.tsx");
